import ArrowIconImg from 'assets/ver2/icons/arrow-left-icon.svg';
import EventsSidebar from 'components/Dashboard/components/EventsSidebar';
import {
  DESKTOP_COLLAPSE_MIN_WIDTH,
  DESKTOP_MIN_WIDTH,
  EXCHANGE_NAV,
  EXCHANGE_TITLE,
  OFFER_NAV,
  OFFER_TITLE,
  ORDER_EMAIL,
  PROFILE_NAV,
  PROFILE_TITLE,
  RECEIVERS_SUB_MENU,
  RECEIVERS_TITLE,
  REMITTANCE_NAV,
  REMITTANCE_TITLE,
} from 'constants';
import Cookies from 'helpers/cookies';
import { MAKE_PAYMENT_KEY } from 'hooks/form-add-transaction/useAddTransaction';
import { FX_MAKE_PAYMENT_KEY } from 'hooks/fx/useFxAddTransaction';
import useLang from 'hooks/useLang';
import usePage from 'hooks/usePage';
import useTheme from 'hooks/useTheme';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { textEllipsisFirstLineMixin } from 'styles';
import useStore from '../../../hooks/useStore';
import {
  SET_MENU_EXPAND,
  SET_REFRESH_RECEIVER_LIST,
  SET_REFRESH_TRANSACTION_LIST,
} from '../../../store/action';
import { getCollapsibleSidebarWidth } from '../func';
import OuterContainer from './OuterContainer';

const CollapsibleSideMenu = ({ children }) => {
  const { t } = useLang();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { dispatch, state } = useStore();
  const { isMenuExpand } = state;
  const { isHHMTTheme } = useTheme();

  const [title, setTitle] = useState({});
  const [navs, setNavs] = useState([]);
  const [currentTab, setCurrentTab] = useState(0);

  const {
    isDashboardPage,
    isReceiversPage,
    isTransactionsPage,
    isEditReceiverPage,
    isUpdateReceiverPage,
    isFxDashboardPage,
    isFxTransactionsPage,
    isOffersVouchersPage,
    isOffersPromotionsPage,
    isOffersPromotionsOfEventPage,
    isProfilePage,
    isSercurityPage,
    isNotificationsPage,
    isReferralPage,
  } = usePage();

  const isNavLinkActive = (href) => pathname === href;

  useEffect(() => {
    if (
      isDashboardPage ||
      isReceiversPage ||
      isEditReceiverPage ||
      isUpdateReceiverPage ||
      isTransactionsPage
    ) {
      setTitle(REMITTANCE_TITLE);
      setNavs(REMITTANCE_NAV);
    } else if (isFxDashboardPage || isFxTransactionsPage) {
      setTitle(EXCHANGE_TITLE);
      setNavs(EXCHANGE_NAV);
    } else if (
      isOffersVouchersPage ||
      isOffersPromotionsPage ||
      isOffersPromotionsOfEventPage
    ) {
      setTitle(OFFER_TITLE);
      setNavs(OFFER_NAV);
    } else if (
      isProfilePage ||
      isSercurityPage ||
      isNotificationsPage ||
      isReferralPage
    ) {
      const profileNavs = isHHMTTheme ? PROFILE_NAV : PROFILE_NAV?.slice(0, -1);
      setTitle(PROFILE_TITLE);
      setNavs(profileNavs);
    } else {
      setTitle({});
      setNavs([]);
    }
  }, [pathname]);

  const handleOnClick = (tabIndex) => {
    dispatch({ type: SET_REFRESH_RECEIVER_LIST, payload: tabIndex });
    dispatch({ type: SET_REFRESH_TRANSACTION_LIST, payload: true });
    setCurrentTab(tabIndex);
  };

  const handleOnToggle = () => {
    dispatch({ type: SET_MENU_EXPAND, payload: !isMenuExpand });
  };

  return (
    <CollapsibleSideMenuContainer>
      <SideMenuStyled $isMenuExpand={isMenuExpand}>
        <SideMenuContainer>
          <PageTitle $isMenuExpand={isMenuExpand}>
            <PageIcon
              src={title.icon}
              width={40}
              height={40}
              $isMenuExpand={isMenuExpand}
            />
            <span>{t(title.text) || null}</span>
          </PageTitle>
          <NavLinks>
            {navs.map((nav) => (
              <NavLink
                key={nav.href}
                to={nav.href}
                onClick={() => {
                  Cookies.remove(MAKE_PAYMENT_KEY);
                  Cookies.remove(FX_MAKE_PAYMENT_KEY);
                  Cookies.remove(ORDER_EMAIL);
                  navigate(nav.href);
                  handleOnClick(0);
                }}
                $isMenuExpand={isMenuExpand}
                $isActive={isNavLinkActive(nav.href)}
              >
                {isNavLinkActive(nav.href) ? (
                  <>
                    {nav.iconActive && (
                      <Icon
                        $isActive={true}
                        src={nav.iconActive}
                        width={24}
                        height={24}
                      />
                    )}
                  </>
                ) : (
                  <>
                    {nav.icon && <Icon src={nav.icon} width={24} height={24} />}
                  </>
                )}
                <span>{t(nav.text) || null}</span>
                {nav?.Badge && <nav.Badge />}
              </NavLink>
            ))}

            {(isDashboardPage || isTransactionsPage) && (
              <NavLink
                key={RECEIVERS_TITLE.href}
                to={RECEIVERS_TITLE.href}
                onClick={() => {
                  Cookies.remove(MAKE_PAYMENT_KEY);
                  navigate(RECEIVERS_TITLE.href);
                  handleOnClick(0);
                }}
                $isMenuExpand={isMenuExpand}
              >
                <Icon src={RECEIVERS_TITLE.icon} width={24} height={24} />
                <span>{t(RECEIVERS_TITLE.text) || null}</span>
              </NavLink>
            )}

            {isReceiversPage && (
              <ReceiversMenu>
                <MenuTitle $isMenuExpand={isMenuExpand}>
                  <Icon
                    src={RECEIVERS_TITLE.iconActive}
                    width={24}
                    height={24}
                  />
                  <span>{t(RECEIVERS_TITLE.text) || null}</span>
                </MenuTitle>
                <SubMenu $isMenuExpand={isMenuExpand}>
                  {RECEIVERS_SUB_MENU.map((nav, index) => (
                    <SubMenuItem
                      key={nav.text}
                      onClick={() => handleOnClick(index)}
                      $isMenuExpand={isMenuExpand}
                      $isActive={currentTab === index}
                    >
                      {currentTab === index ? (
                        <>
                          {nav.iconActive && (
                            <Icon1
                              src={nav.iconActive}
                              width={20}
                              height={20}
                              $isMenuExpand={isMenuExpand}
                              $isActive={true}
                            />
                          )}
                        </>
                      ) : (
                        <>
                          {nav.icon && (
                            <Icon1
                              src={nav.icon}
                              width={24}
                              height={24}
                              $isMenuExpand={isMenuExpand}
                            />
                          )}
                        </>
                      )}
                      <span>{t(nav.text) || null}</span>

                      {currentTab === index ? (
                        <>
                          {nav.iconActive && (
                            <Icon2
                              src={nav.arrowActive}
                              width={16}
                              height={16}
                              $isMenuExpand={isMenuExpand}
                            />
                          )}
                        </>
                      ) : (
                        <>
                          {nav.icon && (
                            <Icon2
                              src={nav.arrow}
                              width={16}
                              height={16}
                              $isMenuExpand={isMenuExpand}
                            />
                          )}
                        </>
                      )}
                    </SubMenuItem>
                  ))}
                </SubMenu>
              </ReceiversMenu>
            )}
          </NavLinks>
          <EventsSidebar />
          <CollapseToggleButton
            $isMenuExpand={isMenuExpand}
            onClick={handleOnToggle}
          >
            <ArrowIcon
              src={ArrowIconImg}
              width={24}
              height={24}
              $isMenuExpand={isMenuExpand}
            />
          </CollapseToggleButton>
        </SideMenuContainer>
      </SideMenuStyled>
      <OuterContainer>{children}</OuterContainer>
    </CollapsibleSideMenuContainer>
  );
};

const CollapsibleSideMenuContainer = styled.div`
  display: flex;
  height: 100dvh;
`;

const SideMenuStyled = styled.div`
  position: fixed;
  top: 72px;
  left: 0;
  height: 100dvh;
  width: ${(props) => getCollapsibleSidebarWidth(props?.$isMenuExpand)};
  transition: width 0.3s ease-in-out;
  display: flex;
  flex-direction: column;

  background-color: var(--ds-c-bg-light-grey);

  padding: 40px 24px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    left: calc(50% - ${DESKTOP_MIN_WIDTH / 2}px);
  }

  @media screen and (min-width: ${DESKTOP_COLLAPSE_MIN_WIDTH}px) {
    left: calc(50% - ${DESKTOP_COLLAPSE_MIN_WIDTH / 2}px);
  }
`;
const SideMenuContainer = styled.div``;

const PageTitle = styled.h3`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 0 20px 0;
  margin: 0 0 20px 0;
  border-bottom: 1px solid var(--ds-c-blue-remox-light);

  span {
    font-family: var(--ff-primary);
    font-style: normal;
    font-weight: 700;
    font-size: 32px;
    line-height: 40px;
    color: var(--ds-c-blue);
  }

  & img {
    margin-left: ${(props) => !props.$isMenuExpand && '10px'};
    margin-right: ${(props) => !props.$isMenuExpand && '5px'};
    transition: 0.3s;
  }

  & span {
    ${textEllipsisFirstLineMixin};
  }
`;
const PageIcon = styled.img``;

const NavLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const NavLink = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;

  width: 100%;
  height: ${(props) => (props.$isMenuExpand ? '60px' : '60px')};
  padding: 0 10px;
  border-radius: 100px;
  background-color: rgba(212, 220, 229, 0.15);

  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #000;
  text-decoration: none;
  cursor: pointer;

  ${(props) =>
    props.$isActive
      ? `
        background-color: var(--ds-c-white);
        box-shadow: 0px 4px 15px 0px #0000001A;
        color: #000;
        font-weight: 700;
      `
      : ``};

  & img {
    margin-left: ${(props) => !props.$isMenuExpand && '8px'};
    transition: 0.3s;
  }

  & span {
    ${textEllipsisFirstLineMixin};
  }
`;
const Icon = styled.img`
  filter: ${(props) =>
    props.$isActive
      ? 'invert(11%) sepia(90%) saturate(7223%) hue-rotate(235deg) brightness(90%) contrast(111%)'
      : 'invert(0%) sepia(96%) saturate(15%) hue-rotate(246deg) brightness(105%) contrast(105%)'};
`;

const ReceiversMenu = styled.div`
  padding: 0 10px;
  border-radius: 8px;
  background-color: var(--ds-c-white);
  box-shadow: 0px 4px 15px 0px #0000001a;
  padding-bottom: 10px;
`;
const MenuTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  width: 100%;
  height: 60px;
  line-height: 50px;
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #000;

  ${(props) =>
    !props.$isMenuExpand &&
    `
        display: none;
        opacity: 0;
        visibility: hidden;
      `};

  & img {
    margin-right: 10px;
    filter: ${(props) =>
      props.$isMenuExpand
        ? 'invert(11%) sepia(90%) saturate(7223%) hue-rotate(235deg) brightness(90%) contrast(111%)'
        : 'invert(0%) sepia(96%) saturate(15%) hue-rotate(246deg) brightness(105%) contrast(105%)'};
  }
`;
const SubMenu = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 0 0 24px;
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;

  ${(props) =>
    props.$isMenuExpand
      ? ``
      : `
        padding-left: 0;
        padding-top: 10px;
    `};
`;
const SubMenuItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 100px;
  height: 40px;
  cursor: pointer;
  padding: 0 10px;

  ${(props) =>
    props.$isActive
      ? `
        background-color: var(--ds-c-blue-remox-hover);
        color: var(--ds-c-white);
      `
      : ``};

  & span {
    ${textEllipsisFirstLineMixin};
  }

  ${(props) =>
    !props.$isMenuExpand &&
    `
    justify-content: center;
    padding: 5px;
    padding-inline: 10px;
    `};
`;
const Icon1 = styled.img`
  ${(props) =>
    props.$isMenuExpand
      ? `
      display: none;
      opacity: 0;
      visibility: hidden;
    `
      : `
      filter: ${
        props.$isActive
          ? 'invert(100%) sepia(0%) saturate(7476%) hue-rotate(348deg) brightness(102%) contrast(101%)'
          : 'invert(0%) sepia(1%) saturate(7489%) hue-rotate(203deg) brightness(89%) contrast(98%)'
      };
  `};
`;
const Icon2 = styled.img`
  ${(props) =>
    props.$isMenuExpand
      ? `
      display: inline-block;
      opacity: 1;
      visibility: visible;
    `
      : `
      display: none;
      opacity: 0;
      visibility: hidden;
  `};
`;

const CollapseToggleButton = styled.button`
  background: transparent;
  width: 24px;
  height: 24px;
  position: absolute;
  bottom: 120px;
  right: 24px;

  left: ${(props) => (props.$isMenuExpand ? '252px' : '37px')};

  border: none;
  cursor: pointer;
`;

const ArrowIcon = styled.img`
  transform: ${(props) =>
    !props.$isMenuExpand ? 'rotate(180deg)' : 'rotate(0deg)'};
  transition: 0.3s ease;
`;

export default CollapsibleSideMenu;
